import Footer from "../home/footer"
import Header from "../home/header"

const shipping=()=>{
    return(
        <>
            <Header/>
            <div className="container-fluid">
                <div className="container">
                    <h2>Shipping Policy</h2>
                    <h3>Last updated: April 22, 2025</h3><br/>

                    Processing Time
                    All orders are delivered within 2-3 business days. Orders are not shipped or delivered on weekends or holidays. If we are experiencing a high volume of orders, shipments may be delayed by a few days. Please allow additional days in transit for delivery. If there will be a significant delay in the shipment of your order, we will contact you via email or phone.
                </div>
            </div>
            <Footer/>
        </>
    )
}

export default shipping